import { useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Splash, useAuth } from '@mobi/web';
import { Auth } from './pages/Auth.js';
import { Home } from './pages/Home.js';
import { Wallet } from './pages/Wallet.js';
import { History } from './pages/History.js';
import { Profile } from './pages/Profile.js';
import { Track } from './pages/Track.js';
import { Shell } from './components/Shell.js';

export function App() {
  const { user, loading } = useAuth();
  const location = useLocation();
  // A troca para a tela real só acontece quando o splash termina a
  // própria saída — não quando `loading` vira false. Sem isto o app
  // corta o splash no meio da animação assim que a sessão resolve rápido.
  const [splashDone, setSplashDone] = useState(false);

  // O link de acompanhamento é para quem não tem conta: não pode esperar
  // sessão, splash, nem cair na tela de login.
  const isPublicTrack = location.pathname.startsWith('/acompanhar/');

  if (isPublicTrack) {
    return (
      <Routes>
        <Route path="/acompanhar/:token" element={<Track />} />
      </Routes>
    );
  }

  if (!splashDone) {
    return (
      <Splash
        role="Passageiro"
        tagline="Sua corrida, na hora certa"
        ready={!loading}
        onFinished={() => setSplashDone(true)}
      />
    );
  }

  if (!user) return <Auth />;

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<Home />} />
        <Route path="/carteira" element={<Wallet />} />
        <Route path="/historico" element={<History />} />
        <Route path="/perfil" element={<Profile />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
